import { useMemo, useState } from 'react';
import { FaxOrg } from '@wetags/fax';
import dayjs from 'dayjs';
import { FaxTypes } from '@frontend/api-fax-legacy';
import { FaxFilters } from '../components/fax-history/fax-filters';
import { FaxHistoryTable } from '../components/fax-history/fax-history-table';
import { FaxHistoryTableV2 } from '../components/fax-history/fax-history-table-v2';

export const FaxHistory = () => {
  const [isFaxHistoryV2Enabled, isFaxHistoryV2Loading] = FaxOrg.useWetag('fax-history-v2');
  const [filters, setFilters] = useState<FaxTypes.FaxFilters>({
    dateRange: [dayjs(new Date()).add(-7, 'day').format('MM/DD/YYYY'), dayjs(new Date()).format('MM/DD/YYYY')],
    recipientNumber: '',
    senderNumber: '',
  });

  const filterQueryString = useMemo(() => {
    const { dateRange, recipientNumber, senderNumber } = filters;
    const startDate = dateRange?.[0];
    const endDate = dateRange?.[1];

    return `?recipient=${recipientNumber}&sender=${senderNumber}&start=${
      startDate ? dayjs(startDate).format('MM-DD-YYYY') : ''
    }&end=${endDate ? dayjs(endDate).format('MM-DD-YYYY') : ''}`;
  }, [filters]);

  return (
    <section>
      {isFaxHistoryV2Loading ? null : isFaxHistoryV2Enabled ? (
        <FaxHistoryTableV2 />
      ) : (
        <>
          <FaxFilters filters={filters} onChange={setFilters} query={filterQueryString} />
          <FaxHistoryTable query={filterQueryString} />
        </>
      )}
    </section>
  );
};
